import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import store from '../../store';

@observer
export default class SimpleList extends React.Component {
	@observable pages = [];

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		const pages = await store.model.PageEditor.find({
			where: { userId: store.model.user.id },
			include: [{ relation: 'page', scope: { fields: ['id', 'title'] } }],
			order: 'id desc',
		});
		this.pages = pages.filter(record => !!record.page);
	};

	render() {
		return (
			<div className="simple-list">
				<ul>
					{this.pages.map(pageEditor => (
						<li key={pageEditor.id}>
							<FontAwesomeIcon icon={faCircle} className="disc" />{' '}
							<Link to={`/admin/static/${pageEditor.pageId}`}>{pageEditor.page.title}</Link>
						</li>
					))}
				</ul>
			</div>
		);
	}
}
